<template>
  <body class="font-montserrat">
    <div class="h-screen bg-black">
      
        <div class="flex justify-between">
            <div class="">
                <div class="h-6 w-20"
                     :class="{'bg-room-green': occupationIndicator === 'free', 'bg-room-red': occupationIndicator === 'occupied', 'bg-yellow-300': occupationIndicator === 'soonOccupied'}">
                </div>
                <div class="absolute inset-0 h-full w-6"
                     :class="{'bg-room-green': occupationIndicator === 'free', 'bg-room-red': occupationIndicator === 'occupied', 'bg-yellow-300': occupationIndicator === 'soonOccupied'}">
                </div>

                <div class="absolute bottom-0 left-0 h-6 w-20"
                     :class="{'bg-room-green': occupationIndicator === 'free', 'bg-room-red': occupationIndicator === 'occupied', 'bg-yellow-300': occupationIndicator === 'soonOccupied'}">
                </div>
            </div>
            <div v-show="showSchedule === false && showConferenceRoomBooking === false" class="absolute top-44 left-60">
                <p class="text-white text-3xl">
                    {{ item.first_name }} {{ item.name}} </p>
            </div>
            <div @click="showSchedule = false; showConferenceRoomBooking = false" class="absolute top-12 right-10">
                <img class="opacity-25 h-16"  src="/files/logo-2021-white.png" alt="logo"/>
            </div>
            <div>
                <div class="flex h-screen w-full justify-center items-center">
                    <div v-show="showConferenceRoomBooking === false" class="grid grid-cols-3">
                        <div class="col-span-3 flex justify-between mt-8">
                            <p @click="showSchedule = false" class="text-white text-8xl mr-10">
                                {{
                                    timestamp.slice(0, 5)
                                }} </p>
                            <div v-show="showSchedule === false" class="box h-full w-1 bg-room-grey"></div>
                            <a @click="showSchedule=true">
                                <div v-show="showSchedule === false" class="ml-6">
                                    <div>
                                        <p v-if="occupationIndicator === 'soonOccupied'"
                                           class="text-yellow-300 text-2xl ">In nächster Zeit reserviert</p>
                                        <p v-if="occupationIndicator === 'free'" class="text-room-green text-2xl ">
                                            Nächstes Meeting</p>
                                        <p v-if="occupationIndicator === 'occupied'" class="text-room-red text-2xl">
                                            Reserviert</p>
                                        <div v-if="nextBooking">
                                            <p class="text-white text-4xl ">{{ nextBooking.start.slice(11, 16) }} -
                                                {{ nextBooking.end.slice(11, 16) }} </p>
                                            <p class="text-white text-2xl">
                                                <span v-if="nextBooking.user">{{ nextBooking.user.name }}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div v-show="occupationIndicator !== 'occupied'" class="col-span-3">
                            <div v-show="!loading" @click="create()" class="text-4xl w-full text-white mt-8 text-center py-8"
                                :class="{'bg-room-green': occupationIndicator === 'free', 'bg-yellow-300': occupationIndicator === 'soonOccupied'}">
                                Jetzt buchen
                            </div>
                            <loading v-show="loading" :is_white=true></loading>
                        </div>
                        <div v-show="occupationIndicator === 'occupied' && nextBooking.comment === 'Displaybuchung'" class="col-span-3">
                            <div v-show="!loading" @click="remove()" class="text-4xl w-full text-white mt-8 text-center py-6 bg-room-red">
                                Freigeben
                            </div>
                            <loading v-show="loading" :is_white=true></loading>
                        </div>
                    </div>
                    <div v-show="showSchedule === true">
                        <div class="bg-black w-96 h-screen relative z-0 ml-12">
                            <div class="absolute inset-0 flex justify-center items-center p-2">
                                <div class="w-full h-full flex justify-center items-center">
                                    <div class="rounded-sm w-96 h-full relative z-0"
                                        :class="{'bg-room-green': occupationIndicator === 'free', 'bg-room-red': occupationIndicator === 'occupied', 'bg-yellow-300': occupationIndicator === 'soonOccupied'}">
                                        
                                        <div class="absolute inset-0 flex justify-center items-center p-2">
                                            <div class="bg-black h-full w-96"></div>
                                        </div>
                                        <div class="absolute inset-0 flex justify-center items-start">
                                            <div class="bg-black h-2 w-72"></div>
                                        </div>
                                        <div class="absolute inset-0 flex justify-center items-end">
                                            <div class="bg-black h-2 w-72"></div>
                                        </div>
                                        <div class="absolute inset-0 flex justify-center items-center p-4">
                                            <div class="bg-room-grey h-full w-96">
                                                <div class="flex justify-center">
                                                    <i class="fa fa-2x fa-chevron-up text-white" aria-hidden="true"></i>
                                                </div>
                                                <div class="flex items-center justify-between ml-6 mt-4 mx-2">
                                                    <p class="text-left text-3xl"
                                                    :class="{'text-room-green ': occupationIndicator === 'free', 'text-room-red': occupationIndicator === 'occupied', 'text-yellow-300': occupationIndicator === 'soonOccupied'}">
                                                        Heute </p>
                                                    <a @click="showSchedule = false; showConferenceRoomBooking = true"
                                                    class="h-16 w-16 rounded-full bg-gray-400 flex items-center justify-center"><i
                                                        class="fa fa-3x fa-plus"
                                                        :class="{'text-room-green ': occupationIndicator === 'free', 'text-room-red': occupationIndicator === 'occupied', 'text-yellow-300': occupationIndicator === 'soonOccupied'}"></i>
                                                    </a>
                                                </div>
                                                <div v-if="bookings" class="flex justify-left items-left ml-6 mt-8">
                                                    <ul role="list" class="overflow-y-scroll max-h-120 w-56 scrollbar-hide">
                                                        <li>
                                                            <div class="relative pb-8" v-for="(booking) in (bookings)" :key=booking.id>
                                                                <div class="flex justify-start items-center space-x-4">
                                                                    <p class="text-xl text-white"> {{ booking.start.slice(11, 16) }}</p>
                                                                    <i class="fa fa-2x fa-long-arrow-right text-white" aria-hidden="true"></i>
                                                                    <p class="text-xl text-white"> {{ booking.end.slice(11, 16) }} </p>
                                                                </div>
                                                                <p class="text-xl text-white mt-2"> {{ booking.comment }} </p>
                                                                <p class="text-xl text-white mt-2" v-if="booking.user">
                                                                    {{ booking.user.first_name }}
                                                                    {{ booking.user.name }}</p>

                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="flex justify-center absolute inset-x-0 bottom-5">
                                                    <i class="fa fa-2x fa-chevron-down text-white" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center" v-show="showConferenceRoomBooking === true">
                        <conference-room-current-time :availability=occupation[0] :id=id :is-occupied="occupation[0].is_occupied" @created="open"></conference-room-current-time>
                        <a class="text-white fa fa-5x fa-angle-left mx-12 mt-24"></a>
                        <div class="flex items-center w-128 overflow-x-auto scrollbar-hide">
                            <div v-for="(availability) in (occupation)" class="mx-6" :key=availability.time>
                                <conference-room-screen-time :availability=availability :id=id :is-occupied="availability.is_occupied"
                                                            @created="open"></conference-room-screen-time>
                            </div>
                        </div>
                        <a class="text-white fa fa-5x fa-angle-right mx-12 mt-24"></a>
                    </div>
                </div>
            </div>
            <div class="">
                <div class="h-6 w-20"
                     :class="{'bg-room-green': occupationIndicator === 'free', 'bg-room-red': occupationIndicator === 'occupied', 'bg-yellow-300': occupationIndicator == 'soonOccupied'}">
                </div>
                <div class="">
                    <div class="ml-auto absolute inset-0 h-full w-6"
                         :class="{'bg-room-green': occupationIndicator === 'free', 'bg-room-red': occupationIndicator === 'occupied', 'bg-yellow-300': occupationIndicator == 'soonOccupied'}">
                    </div>
                </div>
                <div class="absolute bottom-0 right-0 h-6 w-20"
                     :class="{'bg-room-green': occupationIndicator === 'free', 'bg-room-red': occupationIndicator === 'occupied', 'bg-yellow-300': occupationIndicator == 'soonOccupied'}">
                </div>
            </div>
        </div>
        <portal-target name="modal"/>
        
    </div>
    </body>

</template>

<script>
import Card from "../components/UI/Card";
import ButtonPrimary from "../components/UI/ButtonPrimary";
import InputTextSecondary from "../components/UI/InputTextSecondary";
import ButtonWhite from '../components/UI/ButtonWhite';
import sortBy from "lodash/sortBy";
import ConferenceRoomBookingCreate from "../components/ConferenceRoomBookingCreate";
import ConferenceRoomScreenTime from "../components/ConferenceRoomScreenTime";
import ConferenceRoomCurrentTime from "../components/ConferenceRoomCurrentTime";
import Loading from "../components/UI/Loading";
import { startOfMinute } from 'date-fns';

export default {
    name: "ConferenceRoomScreen",
    components: {
        Card,
        ButtonPrimary,
        InputTextSecondary,
        ButtonWhite,
        ConferenceRoomBookingCreate,
        ConferenceRoomScreenTime,
        Loading,
        ConferenceRoomCurrentTime
    },

    props: ['id'],

    data: () => ({
        date: new Date().toISOString().substr(0, 10),
        timestamp: "",
        item: [],
        bookings: [],
        checkedIn: false,
        showSchedule: false,
        showConferenceRoomBooking: false,
        hour: 0,
        loading: false, 
    }),

    mounted() {
        this.open();
    },

    created() {
        setInterval(this.getNow, 1000);
        setInterval(this.open, 60000);
    },

    computed: {
        nextBooking() {
            let filter = this.bookings.filter(b => b.end.slice(11,) > this.timestamp);
            if (filter[0]) {
                return filter[0];
            }
            return null;
        },
        occupationIndicator() {
            if (this.nextBooking) {
                let nextBookingStartHours = this.nextBooking.start.slice(11, 13);
                let nextBookingStartMinutes = this.nextBooking.start.slice(14, 16);
                if (this.timestamp > this.nextBooking.start.slice(11,) && this.timestamp < this.nextBooking.end.slice(11,)) {
                    return 'occupied';
                }
                if (this.timestamp.slice(0, 2) - nextBookingStartHours == '0' && (nextBookingStartMinutes - this.timestamp.slice(3, 5) < '-30' || nextBookingStartMinutes - this.timestamp.slice(3, 5) <= '30')) {
                    return 'soonOccupied';
                }
                if (this.timestamp.slice(0, 2) - nextBookingStartHours == '-1' && (nextBookingStartMinutes - this.timestamp.slice(3, 5) < '-30')) {
                    return 'soonOccupied';
                }
            }
            return 'free';
        },
        timeValues() {
            const today = new Date();
            const start = 0;
            const length = (24 - start) * 2 + 1;
            return Array.from({length}, (_, i) => i).map(i => {
                return {
                    time: (Math.floor(i / 2) + start).toString() + ':' + (i % 2 ? '30' : '00'),
                    is_occupied: false,
                    is_loading: false,
                    hour: Math.floor(i / 2) + start ,
                    minute: (i % 2 ? 30 : 0)
                };
            }).filter(function (time) {
                if(time.hour > today.getHours()) {
                    return true
                }
                if(time.hour == today.getHours() && time.minute == 0 && today.getMinutes() < 30) {
                    return true 
                }
                if(time.hour == today.getHours() && time.minute == 30 ) {
                    return true
                }
                return false; 
            });
        },

        occupation() {
            let occupation = this.timeValues;
            for (let i = 0; i < this.bookings.length; i++) {
                let start = this.bookings[i].start.slice(11, 16);
                let end = this.bookings[i].end.slice(11, 16);
                for (let z = 0; z < this.timeValues.length; z++) {
                    if (occupation[z].time === start) {
                        occupation[z].is_occupied = true;
                    }
                    if (occupation[z].time > start && occupation[z].time < end) {
                        occupation[z].is_occupied = true;
                    }
                }
            }
            return occupation;
        },
    },

    methods: {
        getNow() {
            const today = new Date();
            const time = ("0" + today.getHours()).slice(-2) + ":" + ("0" + today.getMinutes()).slice(-2) + ":" + ("0" + today.getSeconds()).slice(-2);
            this.timestamp = time.substr(0, 10);
            const hour = parseInt(this.timestamp.substr(0, 2));
            if (hour !== this.hour) {
                this.hour = hour;
            }
        },
        open() {
            window.axios
                .get('/panel/conference_rooms/' + this.id)
                .then(response => {
                    this.item = response.data.data;
                    this.bookings = sortBy(response.data.data.bookings, 'start');
                    this.loading = false;
                })
                .catch(error => {
                    //alert("Raum nicht gefunden");
                    this.$root.$emit('error', error);
                });
        },
        create() {
            this.loading = true;
            const [hour, minute] = this.timestamp.slice(0, 5).split(':');
            const today = (new Date).toISOString().substring(0,10);
            window.axios.post('/panel/conference_rooms', {
                start: today + ' ' + (minute < '30' ? ((hour) + ':00') : (hour + ':30')),
                end: today + ' ' + (minute >= '30' ? ((parseInt(hour)+1) + ':00') : (hour + ':30')),
                comment: 'Displaybuchung',
                conference_room_id: this.id,
            }).then(() => {
                this.open();
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
        remove() {
            this.loading = true;
            window.axios.post('/panel/conference_room_bookings/' + this.nextBooking.id, {
                _method: 'delete',
                uuid: this.id,
            }).then(()=> {
                this.loding = false;
                this.open();
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

.scrollbar-hide {
    -ms-overflow-style: none; 
    scrollbar-width: none;  
}

/* montserrat-regular - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/montserrat-v25-latin-regular.eot'); /* IE9 Compat Modes */
    src: url('/fonts/montserrat-v25-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('/fonts/montserrat-v25-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
    url('/fonts/montserrat-v25-latin-regular.woff') format('woff'), /* Modern Browsers */
    url('/fonts/montserrat-v25-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
    url('/fonts/montserrat-v25-latin-regular.svg#Montserrat') format('svg'); /* Legacy iOS */
}

</style>
